<mat-toolbar color="primary" class="main-toolbar">
    <mat-toolbar-row>
        <img src={{currentApplicationLogo}} alt="Logo" class="header-logo">
        <div *ngIf="!isLoggedIn">{{currentApplicationTitle}}</div>

        <button mat-button [matBadge]="badgeVal" [matBadgeHidden]="badgeVal == '0'" matBadgeColor="warn"
            class="nav-bar-button" routerLink="/pTickets/list" routerLinkActive="active" *ngIf="isLoggedIn">
            Ticket Overview
            <mat-icon>home</mat-icon>
        </button>

        <button mat-flat-button color="primary" (click)="onOpenReporting()" class="nav-bar-button" *ngIf="isLoggedIn"
            routerLink="/reporting/map" routerLinkActive="active"><mat-icon>map</mat-icon>Map</button>

        <button mat-flat-button color="primary" (click)="onOpenReportingOverview()" class="nav-bar-button"
            *ngIf="isLoggedIn" routerLink="/reporting/overview"
            routerLinkActive="active"><mat-icon>equalizer</mat-icon>Reporting</button>

        <button mat-flat-button color="primary" class="nav-bar-button" *ngIf="isLoggedIn && isOrganizationAdmin && !isSystemAdmin"
            routerLink="/administration/panel" routerLinkActive="active">
            <mat-icon>manage_accounts</mat-icon> Organization Administration
        </button>

        <button mat-flat-button color="primary" class="nav-bar-button" *ngIf="isLoggedIn && isSystemAdmin"
            routerLink="/administration/superadmin/panel" routerLinkActive="active">
            <mat-icon>admin_panel_settings</mat-icon> System Administration
        </button>


        <span class="example-spacer"></span>
        <button mat-flat-button color="primary" [matMenuTriggerFor]="organizationMenu"
            *ngIf="(isLoggedIn && organizationList.length > 1 && currentOrganization != 'Report only')">
            logged in to {{this.currentOrganization}} </button>

        <button mat-flat-button color="primary"
            *ngIf="(isLoggedIn && (organizationList.length == 1 || currentOrganization == 'Report only'))">
            logged in to {{this.currentOrganization}} </button>

        <button mat-icon-button [matMenuTriggerFor]="userMenu"
            *ngIf="isLoggedIn"><mat-icon>account_circle</mat-icon></button>
    </mat-toolbar-row>

</mat-toolbar>
<mat-toolbar color="primary" class="main-toolbar-mobile">
    <mat-toolbar-row>
        <div *ngIf="!isLoggedIn">{{currentApplicationTitle}}</div>
        <button mat-icon-button (click)="menuClick.emit()" color="secondary"
            *ngIf="isLoggedIn"><mat-icon>list</mat-icon></button>
        <span class="example-spacer"></span>
        <button mat-flat-button color="primary" [matMenuTriggerFor]="organizationMenu"
            *ngIf="(isLoggedIn && organizationList.length > 1 && currentOrganization != 'Report only')">
            {{this.currentOrganization}} </button>

        <button mat-icon-button [matMenuTriggerFor]="userMenu"
            *ngIf="isLoggedIn"><mat-icon>account_circle</mat-icon></button>
    </mat-toolbar-row>
</mat-toolbar>
<ng-container *ngIf="isLoggedIn">
    <mat-progress-bar [value]="sessionPercent$ | async" mode="determinate" color="secondary" style="width: 100%;">
    </mat-progress-bar>
</ng-container>

<mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="onProfileClick()">
        <mat-icon>account_circle</mat-icon> Profile
    </button>
    <button mat-menu-item (click)="onLogoutClick()">
        <mat-icon>logout</mat-icon> Logout
    </button>
    <div mat-menu-item disabled="true">
        <mat-icon>tag</mat-icon> {{ currentApplicationVersion }}
    </div>
</mat-menu>


<mat-menu #organizationMenu="matMenu">
    <button mat-menu-item *ngFor="let organization of organizationList"
        (click)="onOrganizationChangeClick(organization)">{{organization.org_name}}</button>
</mat-menu>